// Stub page that the NICE BYOC integration-box's Add / Reconnect / Remove
// action URLs point at. NICE's admin UI requires those fields to save,
// but our API-only flow doesn't need the redirect round-trip anymore.
//
// If a NICE admin ever clicks "Add Channel" or "Remove" from inside CXone,
// they land here and are told the integration is managed from Agent Studio.
// Non-project route (not under /:accountId/:projectId) so the URL the
// customer pastes into NICE is static.

import Button from '@polyai/ui/components/atoms/Button';
import Callout, { CalloutType } from '@polyai/ui/components/atoms/Callout';
import Text from '@polyai/ui/components/atoms/Text';

const NiceByocRedirectScreen = () => {
  return (
    <div className="max-w-xl mx-auto p-md flex flex-col gap-sm3">
      <Text variant="headerMedium">PolyAI NICE integration</Text>
      <Callout type={CalloutType.NEUTRAL} hideIcon>
        <div className="flex flex-col gap-xs2">
          <Text>
            This integration is managed from Agent Studio — there&apos;s nothing
            to do here.
          </Text>
          <Text variant="bodySmall" className="text-helper">
            NICE requires URLs to be configured for Add / Reconnect / Remove
            channel actions, but PolyAI handles channel management through the
            Agent Studio Integrations page instead of a redirect flow.
          </Text>
        </div>
      </Callout>
      <Button
        label="Go to Agent Studio"
        size="regular"
        variant="PRIMARY"
        onClick={() => {
          window.location.assign('/');
        }}
      />
    </div>
  );
};

export default NiceByocRedirectScreen;
